import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import './index.css';
import { registerServiceWorker } from './pwa/register';
import { initErrorReporting } from './lib/error-reporting';
import { startOfflineNoticeListener } from './lib/offline-notice';

// CP12: service worker + error tracking (Sentry ter-konfigurasi DSN; kosong =
// tidak dimuat). Keduanya best-effort — kegagalan tidak boleh mematikan UI.
void registerServiceWorker();
void initErrorReporting();
const stopOfflineNotice = startOfflineNoticeListener();
if (import.meta.hot) import.meta.hot.dispose(() => stopOfflineNotice());

// Data asinkron lewat TanStack Query (code-standards.md). Mutation submit
// laporan tidak diulang otomatis: user yang memutuskan mencoba lagi.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false },
    mutations: { retry: false },
  },
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Elemen #root tidak ditemukan di index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
